// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={32}
      height={32}
      fill="none"
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      {...props}
    >
      <path d="m16 2 4 10h10l-8 7 3 11-9-7-9 7 3-11-8-7h10z" />
    </svg>
  );
};

const StarIcon = Icon;
export default StarIcon;
